import React from 'react'

export default function Hero1() {
  return (
    <div className='fondito'>
    <div
className="hero min-h-screen background-i ">
<div className="hero fondito min-h-screen">
<div className="hero-content text-center">
  <div className="max-w-md">
    <h1 className="text-5xl font-bold">Revolucionando el Transporte en Chile</h1>
    <p className="py-6">
    Busia.cl es una plataforma tecnológica innovadora que está transformando la forma en que las personas se desplazan en Chile.
    </p>
    <button className="btn btn-primary">Quiero saber más</button>
  </div>
</div>
</div>
</div>
  </div>
  )
}
